import React, { useEffect } from 'react';
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import CaptureFAB from './CaptureFAB';
import { Loader2 } from 'lucide-react';

const SESSION_FLAG = 'atlas_session_started';

const MainLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Fresh-launch redirect: on cold open (new browser session),
  // always land on the Accueil (Dashboard), not wherever Safari remembered.
  useEffect(() => {
    if (loading || !isAuthenticated) return;
    let alreadyStarted = false;
    try {
      alreadyStarted = sessionStorage.getItem(SESSION_FLAG) === '1';
      sessionStorage.setItem(SESSION_FLAG, '1');
    } catch {
      alreadyStarted = true; // storage blocked → don't force redirect
    }
    if (!alreadyStarted && location.pathname !== '/dashboard') {
      navigate('/dashboard', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isAuthenticated]);

  if (loading) {
    return (
      <div className="min-h-screen bg-atlasBg flex items-center justify-center">
        <div className="text-center">
          <h1 className="atlas-brand text-4xl text-atlasCyan mb-4 tracking-wider">ATLAS</h1>
          <Loader2 className="w-6 h-6 text-atlasCyan animate-spin mx-auto" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-atlasBg flex">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Main Content */}
      <main className="flex-1 h-screen overflow-auto pb-20 lg:pb-0">
        <Outlet />
      </main>

      {/* Mobile Navigation */}
      <MobileNav />

      {/* Capture FAB */}
      <CaptureFAB />
    </div>
  );
};

export default MainLayout;
